<template>
  <div>
    <div class="row page-title-header">
      <div class="col-12">
        <div class="page-header">
          <b-breadcrumb class="m-0">
            <b-breadcrumb-item :to="{
              name: 'DashboardHome',
            }">
              <i class="fa fa-home"></i>
            </b-breadcrumb-item>
            <b-breadcrumb-item
              :to="{
                name: 'OrganizationHome',
              }"
            >
              組織資料設定
            </b-breadcrumb-item>
            <b-breadcrumb-item
              :to="{
                name: 'ModuleList',
              }"
            >
              模組管理
            </b-breadcrumb-item>
            <b-breadcrumb-item active>
              模組設定
            </b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </div>
    </div>

    <b-card>
      <div class="row mb-2 align-items-end">
        <div class="col-8 d-flex items-center">
          <h4 class="font-weight-bold">【{{organization.name}}】模組設定
            <b-button class="ml-3" variant="inverse-warning" @click="$router.push({ name: 'ModuleEdit' })">
              <span class="mdi mdi-lead-pencil"></span> 模組編輯
            </b-button>
          </h4>
        </div>
      </div>

      <b-overlay :show="isLoading" rounded opacity="0.6" spinner-small spinner-variant="primary">
        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="sm"
          label="模組名稱"
          >
          <b-form-input
            class="mb-2 mr-sm-2 mb-sm-0"
            type="text"
            v-model="name"
            readonly
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="sm"
          label="模組代號"
          >
          <b-form-input
            class="mb-2 mr-sm-2 mb-sm-0"
            type="text"
            v-model="code"
            readonly
          ></b-form-input>
        </b-form-group>
        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="sm"
          label="通路"
          label-for="merchant"
        >
          <b-form-input
            id="merchant"
            :value="merchantDisplayName"
            readonly
          ></b-form-input>
        </b-form-group>
        
        <b-form-group
          label-cols="12"
          label-cols-lg="2"
          label-size="m"
          :label="forms[0] && forms[0].category"
          label-class="font-weight-bold"
          class="group pt-4"
          v-for="(forms, i) in formGroups" :key="i"
        >
          <section class="row mb-8">
            <div class="col-12 col-xl-8">
              <b-form-group
                label-cols="12"
                label-cols-lg="2"
                label-size="sm"
                :description="f.description || ''"
                :label="f.name || ''"
                :label-for="f.key || ''" v-for="f in forms" :key="f.id"
                >
                <b-form-checkbox
                  v-if="f.type == 'boolean'"
                  :id="f.key"
                  class="mb-2 mr-sm-2 mb-sm-0"
                  v-model="form[f.key]"
                  :name="f.key"
                  :value="true"
                  :unchecked-value="false"
                ></b-form-checkbox>
                <color-picker :id="f.key" v-model="form[f.key]" v-else-if="f.type == 'color'"></color-picker>
                <b-form-checkbox-group
                  v-else-if="f.type == 'array' && f.config && f.config['ui-data'] && f.config['ui-data']['type'] == 'array-checkbox'"
                  :id="f.key"
                  class="mb-2 mr-sm-2 mb-sm-0"
                  v-model="form[f.key]"
                  :options="f.config['ui-data']['options']"
                  :name="f.key"
                ></b-form-checkbox-group>
                <!-- 條款陣列編輯器：僅適用於 member_register.terms_page.content -->
                <TermsArrayEditor
                  v-else-if="f.type == 'array' && isTermsArrayField(f.key)"
                  :id="f.key"
                  v-model="form[f.key]"
                />
                <editor
                  v-else-if="f.type == 'json' || f.type == 'array'"
                  :id="f.key"
                  class="mb-2 mr-sm-2 mb-sm-0"
                  v-model="form[f.key]"
                  width="100%"
                  height="200px"
                  @init="editorInit"
                  lang="json"
                  theme="chrome"
                >
                </editor>
                <editor
                  v-else-if="f.type == 'html'"
                  :id="f.key"
                  class="mb-2 mr-sm-2 mb-sm-0"
                  v-model="form[f.key]"
                  width="100%"
                  height="200px"
                  @init="editorInit"
                  lang="html"
                  theme="chrome"
                >
                </editor>
                <b-form-input
                  v-else-if="f.type == 'number'"
                  :id="f.key"
                  class="mb-2 mr-sm-2 mb-sm-0"
                  type="number"
                  v-model="form[f.key]"
                ></b-form-input>
                <button
                  v-else-if="f.type == 'file'"
                  class="btn btn-link px-2 text-dark align-self-start upload-button"
                >
                  <b-form-file
                    @change="upload($event, f.key)"
                    placeholder="尚未選擇檔案" browse-text="瀏覽"
                  />
                    <a v-if="!!form[f.key]" @click="form[f.key] = null" class="btn-sm btn-outline-danger"><i class="fa fa-trash-o"></i></a>
                    <a :href="form[f.key]" target="_blank"><small> 目前路徑：{{form[f.key] || '未上傳'}} </small></a>
                </button>
                <b-form-select
                  v-else-if="f.type == 'string' && f.config && f.config['ui-data'] && f.config['ui-data']['type'] == 'select'"
                  :options="(f.config['ui-data'] && f.config['ui-data']['options']) || {}"
                  :id="form.key"
                  class="mb-2 mr-sm-2 mb-sm-0"
                  v-model="form[f.key]"
                  :state="v$.form[f.key] && v$.form[f.key].$error ? false : null"
                ></b-form-select>
                <b-form-radio-group
                  v-else-if="f.type == 'string' && f.config && f.config['ui-data'] && f.config['ui-data']['type'] == 'radio'"
                  :options="(f.config['ui-data'] && f.config['ui-data']['options']) || {}"
                  :id="form.key"
                  class="mb-2 mr-sm-2 mb-sm-0"
                  v-model="form[f.key]"
                  :state="v$.form[f.key] && v$.form[f.key].$error ? false : null"
                ></b-form-radio-group>
                <b-form-input
                  v-else
                  :id="form.key"
                  class="mb-2 mr-sm-2 mb-sm-0"
                  type="text"
                  v-model="form[f.key]"
                  :placeholder="getFieldPlaceholder(f.key)"
                  :state="v$.form[f.key] && v$.form[f.key].$error ? false : null"
                ></b-form-input>

                <b-form-invalid-feedback
                 :state="v$.form[f.key] && v$.form[f.key].$error ? false : null"
                 v-for="(error, i) in v$.form[f.key].$errors" :key="i"
                >
                  {{error.$message || '欄位為必填'}}
                </b-form-invalid-feedback>
              </b-form-group>

            </div>
          </section>
        </b-form-group>

        <b-form-group
          v-if="isLiffPageModuleWithTree"
          label-cols="12"
          label-cols-lg="2"
          label-size="m"
          label="page"
          label-class="font-weight-bold"
          class="group pt-4"
        >
          <section class="row mb-8">
            <div class="col-12 col-xl-10">
              <LiffPageConfigTreeEditor
                :module-code="code"
                :form="form"
                :page-config-tree="pageConfigTree"
                @add-page="handleAddPage"
                @remove-page="handleRemovePage"
              />
            </div>
          </section>
        </b-form-group>
      </b-overlay>

      <div class="d-flex justify-content-center">
        <b-button class="mr-4" variant="outline-danger" @click="handleCancel">取消</b-button>
        <b-overlay
          :show="isSubmmiting"
          rounded
          opacity="0.6"
          spinner-small
          spinner-variant="primary"
          class="d-inline-block"
        >
          <b-button class="mr-2" variant="success" @click="handleSubmit(false)" :disabled="isLoading">
            儲存
          </b-button>
          <b-button variant="success" @click="handleSubmit" :disabled="isLoading">
            儲存後關閉
          </b-button>
        </b-overlay>
      </div>
    </b-card>
  </div>
</template>

<style scoped lang="scss">
.group+.group {
  border-top: 1px solid #cdd6dc !important;
}
</style>
<script>
import { reactive } from "@vue/composition-api";
import { mapState, mapGetters } from "vuex";
import useVuelidate from "@vuelidate/core";
import { required, numeric, helpers } from "@vuelidate/validators";
import moduleApi from "../../../apis/module";
import merchantApi from "../../../apis/merchant";
import * as consts from "@/consts";
import PermissionChecker from "@/utils/PermissionChecker";
import editor from 'vue2-ace-editor'
import fileMixin from "@/mixins/uploadFile";
import _ from 'lodash'
import ColorPicker from '@/components/ColorPicker'
import TermsArrayEditor from '@/components/Dashboard/TermsArrayEditor'
import LiffPageConfigTreeEditor from '@/components/Dashboard/ModuleConfig/LiffPageConfigTreeEditor'

const mustBeJson = (value) => {
  try {
    if (typeof value === 'string')
      JSON.parse(value)
    return {$valid: true}
  } catch (e) {
    return {
      $valid: false,
      message: '必須為 JSON 格式'
    }
  }
};

const mustBeArray = (value) => {
  try {
    if ((typeof value === 'string' &&  Array.isArray(JSON.parse(value))) || Array.isArray(value)) {
      return {$valid: true}
    }
    return {
      $valid: false,
      message: '必須為 Array 格式'
    }
  } catch (e) {
    return {
      $valid: false,
      message: '必須為 Array 格式'
    }
  }
};

export default {
  mixins: [fileMixin],
  components: {editor, 'color-picker': ColorPicker, TermsArrayEditor, LiffPageConfigTreeEditor},
  validationConfig: {
    $lazy: true,
  },
  setup: () => ({ v$: useVuelidate() }),
  data() {
    /*
     *  由於欄位是個動態 array ，因此 vuelidate 幾乎觸發不了驗證
     * ，因此編輯時暫時將
     *  forms = [{key: 'k', value: 'v'}]
     *  轉為form = {k:v}
     *  最後 submit 再轉換回來
    */
    return {
      code: null,
      name: null,
      color: '',
      isLoading: false,
      isSubmmiting: false,
      isFetchMerchants: false,
      forms: [],
      form: reactive({}),
      formGroups: {},
      pageConfigTree: {},
      deletedPagePrefixes: [],
      merchant_id: null,
      merchants: [{ value: null, text: "請選擇通路" }],
    };
  },
  computed: {
    ...mapState("general", {
      organization: (state) => state.organization,
    }),
    ...mapGetters({
      getModuleConfig: "dashboardModule/getConfig",
    }),
    ...mapGetters("route", ["routeQuery"]),
    merchantDisplayName() {
      const found = this.merchants.find(m => m.value === this.form.merchant_id)
      return found ? found.text : (this.form.merchant_id || '品牌組織階層')
    },
    orgId() {
      return this.$route.params.orgId;
    },
    moduleId() {
      return this.$route.params.moduleId;
    },
    isLiffPageModuleWithTree() {
      return this.code === 'liff_page'
    },
  },
  validations() {
    let rules = {
      form: {},
    }
    this.forms.forEach(form => {
      rules.form[form.key] = {
      }
      if (form.config && !!form.config.required) {
        rules.form[form.key] = {
          required: helpers.withMessage('此欄位為必填', required)
        }
      }
      switch (form.type) {
        case 'number':
          rules.form[form.key]['numeric'] = helpers.withMessage('此欄位必須為數字', numeric)
          break
        case 'json':
          rules.form[form.key]['mustBeJson'] = helpers.withMessage('此欄位必須為 JSON 格式', mustBeJson)
          break
        case 'array':
          rules.form[form.key]['mustBeArray'] = helpers.withMessage('此欄位必須為 Array 格式', mustBeArray)
          break
      }
    })
    return rules
  },
  mounted() {
    if (!this.checkPermission([consts.MERCHANT_MODIFY])) {
      this.$swal
        .fire({
          type: "error",
          text: "你沒有權限訪問此頁面",
          confirmButtonColor: "#d33"
        })
        .then(() => {
          this.$router.push({ name: "ModuleList" });
        });
    } else if (this.moduleId) {
      this.fetchModule();
    }
    this.getMerchants();
  },
  methods: {
    async getMerchants() {
      this.isFetchMerchants = true;
      const { data } = await merchantApi.list();
      this.isFetchMerchants = false;

      this.merchants = [
        { value: "null", text: "品牌組織階層" },
        ...data.data.map((merchant) => {
          return {
            value: merchant.id,
            text: merchant.type_name
              ? `${merchant.name} (${merchant.type_name})`
              : merchant.name,
          };
        }),
      ];
    },
    /**
     * 判斷是否為條款陣列欄位
     * 當欄位 key 包含 'terms' 且資料結構為包含 title, content_text 的陣列時返回 true
     * @param {String} key - 欄位的 key 值
     * @returns {Boolean}
     */
    isTermsArrayField(key) {
      // 只有 member_register.terms_page.content 使用條款陣列編輯器
      return key === 'member_register.terms_page.content'
    },
    /**
     * 取得欄位的 placeholder 提示文字
     * @param {String} key - 欄位的 key 值
     * @returns {String}
     */
    getFieldPlaceholder(key) {
      const placeholders = {
        'member_register.terms_page.terms_check': '預設值：已詳閱使用須知並同意相關使用說明'
      }
      return placeholders[key] || ''
    },
    editorInit () {
        require('brace/ext/language_tools') //language extension prerequsite...
        require('brace/mode/json')
        require('brace/mode/html')
        require('brace/theme/chrome')
    },
    ensurePageConfigTreeFormValues(pageConfigTree, moduleCode) {
      if (!pageConfigTree || !moduleCode) {
        return
      }

      Object.entries(pageConfigTree).forEach(([pageKey, pageConfig]) => {
        Object.entries(pageConfig || {}).forEach(([fieldKey, value]) => {
          const fullKey = `${moduleCode}.${pageKey}.${fieldKey}`
          if (this.form[fullKey] !== undefined) {
            return
          }

          if (Array.isArray(value) || (value && typeof value === 'object')) {
            this.$set(this.form, fullKey, JSON.stringify(value, null, 2))
            return
          }

          this.$set(this.form, fullKey, value)
        })
      })
    },
    syncLiffPageTreeFieldsToForms(pageConfigTree, moduleCode) {
      if (!pageConfigTree || !moduleCode) {
        return
      }

      Object.entries(pageConfigTree).forEach(([pageKey, pageConfig]) => {
        Object.entries(pageConfig || {}).forEach(([fieldKey, value]) => {
          const fullKey = `${moduleCode}.${pageKey}.${fieldKey}`
          if (this.forms.find(form => form.key === fullKey)) {
            return
          }

          let type = 'string'
          if (typeof value === 'boolean') {
            type = 'boolean'
          } else if (typeof value === 'number') {
            type = 'number'
          } else if (Array.isArray(value)) {
            type = 'array'
          } else if (value && typeof value === 'object') {
            type = 'json'
          }

          this.forms.push({
            key: fullKey,
            type,
            value: this.form[fullKey],
            name: fieldKey,
            description: '',
            config: null,
            category: pageKey,
            order: 999,
          })
        })
      })
    },
    async fetchModule() {
      try {
        this.isLoading = true;
        const { data } = await moduleApi.getModuleConfigMap(this.orgId, this.moduleId);
        this.name = data.meta.name
        this.code = data.meta.code
        this.pageConfigTree = data.page_config_tree || {}
        this.merchantId = data.meta.merchant_id
        this.$set(this.form, "merchant_id", this.merchantId)
        this.forms  = data.data.map(form => {
          switch (form.type) {
            case 'json':
            case 'array':
              if (form.type == 'array' &&
                form.config &&
                form.config['ui-data'] &&
                form.config['ui-data']['type'] == 'array-checkbox') {
                  form.config['ui-data']['options'] = form.config['ui-data']['options'].sort((a, b) => a.order - b.order)
                  form.value = form.value || []
                  break
              }
              form.value = JSON.stringify(form.value, null, 2) || ''
              break
            case'string':
              form.value = form.value || ''
              break
          }
          this.$set(this.form, form.key, form.value)
          return form
        });
        this.formGroups = _(this.forms)
          .groupBy(form => form.category)
          .map(group => _(group).orderBy('order').value())
          .sortBy((g) => {
              return g && g[0].category
          })
          .value()

        if (this.code === 'liff_page') {
          this.ensurePageConfigTreeFormValues(this.pageConfigTree, this.code)
          this.syncLiffPageTreeFieldsToForms(this.pageConfigTree, this.code)
        }
      } catch (error) {
        console.error("error", error);
        console.log("");
      } finally {
        this.isLoading = false;
      }
    },
    async upload(e, key) {
      this.isLoading = true
      let url = ''
      if (key.includes('sample_file') && key.includes('xls.url')) {
        const fileName = this.form[key.replace('url', 'file_name')]
        if(fileName) {
          url =  await this.uploadFile(e.target.files[0], fileName)
        } else {
          url =  await this.uploadFile(e.target.files[0])
        }
      } else {
        url =  await this.uploadFile(e.target.files[0])
      }
      this.form[key] = url
      this.isLoading = false
      return url
    },
    /**
     * 新增 liff_page 頁面：在 pageConfigTree、forms、form 同步加入新頁面所有欄位
     * @param {string} pageKey - 頁面識別代號，例如 advocate_page
     * @param {Object} defaultValues - 各欄位預設值
     */
    handleAddPage(pageKey, defaultValues) {
      const prefix = `${this.code}.${pageKey}.`

      if (!this.pageConfigTree) {
        this.$set(this, 'pageConfigTree', {})
      }

      // 若原本在刪除清單中，代表使用者重新加回頁面，需移除刪除標記
      this.deletedPagePrefixes = this.deletedPagePrefixes.filter((item) => item !== prefix)

      // 1. 更新 pageConfigTree（驅動子元件重新渲染）
      this.$set(this.pageConfigTree, pageKey, { ...defaultValues })

      // 2. 將各欄位以扁平 key 寫入 form 與 forms
      Object.entries(defaultValues).forEach(([fieldKey, value]) => {
        const fullKey = `${this.code}.${pageKey}.${fieldKey}`
        const type = typeof value === 'boolean' ? 'boolean' : 'string'

        // 寫入 form（供儲存時讀取）
        this.$set(this.form, fullKey, value)

        // 寫入 forms（供 vuelidate 驗證與提交序列化讀取）
        if (!this.forms.find(f => f.key === fullKey)) {
          this.forms.push({
            key: fullKey,
            type,
            value,
            name: fieldKey,
            description: '',
            config: null,
            category: pageKey,
            order: 999,
          })
        }
      })
    },

    /**
     * 刪除 liff_page 頁面：從 pageConfigTree、forms、form 移除該頁面所有欄位
     * @param {string} pageKey - 頁面識別代號，例如 advocate_page
     */
    handleRemovePage(pageKey) {
      const prefix = `${this.code}.${pageKey}.`

      // 紀錄刪除清單，儲存時由後端依 prefix 移除舊資料
      if (!this.deletedPagePrefixes.includes(prefix)) {
        this.deletedPagePrefixes.push(prefix)
      }

      // 1. 從 pageConfigTree 中刪除該頁面
      this.$delete(this.pageConfigTree, pageKey)

      // 2. 從 forms 陣列中移除該頁面所有欄位
      this.forms = this.forms.filter(f => !f.key.startsWith(prefix))

      // 3. 從 form 物件中移除對應 key
      Object.keys(this.form).forEach(key => {
        if (key.startsWith(prefix)) {
          this.$delete(this.form, key)
        }
      })
    },
    async handleSubmit(redirect = true) {
      const result = await this.v$.$validate();
      if (!result) {
        // 找到第一個有錯誤的欄位
        const firstError = this.findFirstError();
        if (firstError) {
          this.scrollToError(firstError);
        }
        return;
      }
      this.handleUpdate(redirect);

    },
    async handleUpdate(redirect = true) {
      try {
        this.isSubmmiting = true;
        let forms  = this.forms.map(form => {
          form.value = this.form[form.key]
          if (form.type == 'json' || form.type == 'array') {
              if (form.type == 'array' &&
                form.config &&
                form.config['ui-data'] &&
                form.config['ui-data']['type'] == 'array-checkbox') {
                return form
              }
            return {...form, value: JSON.parse(form.value)}
          }
          return form
        });
        let module = {
            data: forms,
            merchant_id: this.form.merchant_id,
            delete_prefixes: this.deletedPagePrefixes
        }
        await moduleApi.updateModuleConfigMap(this.orgId, this.moduleId, module);
        this.deletedPagePrefixes = []
        this.showSuccessPopup(redirect);
      } catch (error) {
        console.log(error)
        const { status, data } = error.response;
        if (status && status === 422 && data.message) {
          const html = Object.values(data.message)
            .map((m) => m[0])
            .join("<br/>");
          this.$swal.fire({
            type: "error",
            html,
          });
        }
      }
      this.isSubmmiting = false;
    },
    handleCancel() {
      this.$router.push({ name: "ModuleList", query: this.routeQuery });
    },
    showSuccessPopup(redirect = true) {
      this.$swal
        .fire({
          type: "success",
          text: "修改成功",
        })
        .then(() => {
          if (redirect) {
            this.$router.push({ name: "ModuleList", query: this.routeQuery });
          }
        });
    },
    checkPermission(permissions) {
      const checker = new PermissionChecker();
      return checker.check(permissions);
    },
    findFirstError() {
      // 遍歷所有表單欄位，找到第一個有錯誤的
      for (const form of this.forms) {
        const field = this.v$.form[form.key];
        if (field && field.$error) {
          return form.key;
        }
      }
      return null;
    },
    scrollToError(fieldKey) {
      this.$nextTick(() => {
        
        //const element = document.getElementById(fieldKey);
        const element = document.querySelector(`label[for="${fieldKey}"]`)
        
        if (element) {
          element.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'center' 
          });
          // 聚焦到元素（如果是可聚焦的）
          if (element.focus) {
            element.focus();
          }
        }
      });
    },
  },
};
</script>
